import { useState } from 'react';
import type { CleaningRangeSummaryResponse } from '@/shared/api';
import { useContainerQuery } from '@/shared/hooks/useContainerQuery';
import { CleaningDayAgenda } from './CleaningDayAgenda';
import type { OperationalApartmentRow } from './cleaningOperationalRows';
import { CleaningWeekGrid } from './CleaningWeekGrid';

/**
 * Die Woche (lesend): ab 720 px Breite des Inhalts das Raster Apartment × Tag, schmaler die
 * Tagesleiste mit den Apartments des gewählten Tages — am Handy passt kein Raster aus sieben Spalten.
 */
export function CleaningWeek({
  rows,
  weekDates,
  date,
  today,
  selectedId,
  onSelect,
}: {
  rows: OperationalApartmentRow[];
  weekDates: string[];
  date: string;
  today: string;
  selectedId: string | null;
  onSelect: (task: CleaningRangeSummaryResponse, trigger: HTMLElement) => void;
}) {
  const { ref, matches: wide } = useContainerQuery(720);
  const initial = weekDates.includes(date)
    ? date
    : weekDates.includes(today)
      ? today
      : weekDates[0];
  const [picked, setPicked] = useState<string | null>(null);
  const day = picked && weekDates.includes(picked) ? picked : (initial ?? date);
  return (
    <div ref={ref}>
      {wide ? (
        <CleaningWeekGrid
          rows={rows}
          weekDates={weekDates}
          todayIso={today}
          selectedId={selectedId}
          onSelect={onSelect}
        />
      ) : (
        <CleaningDayAgenda
          rows={rows}
          weekDates={weekDates}
          selectedDay={day}
          onSelectDay={setPicked}
          todayIso={today}
          selectedId={selectedId}
          onSelect={onSelect}
        />
      )}
    </div>
  );
}
